// extracted by mini-css-extract-plugin
export default {"chat":"chat__3Eh6C","textbox":"textbox__1mKga","speaker":"speaker__3K4G8","typing":"typing__1YRtD","emph":"emph__LEVFh","disabled":"disabled__3mWDk"};